import React from 'react';
import { Hero } from '../components/Hero';
import { WhoThisIsFor } from '../components/WhoThisIsFor';
import { Testimonials } from '../components/Testimonials';
import { LifestyleGallery } from '../components/LifestyleGallery';
import { WhyNow } from '../components/WhyNow';
import { Curriculum } from '../components/Curriculum';
import { Experience } from '../components/Experience';
import { Faculty } from '../components/Faculty';
import { Pricing } from '../components/Pricing';
import { ApplicationProcess } from '../components/ApplicationProcess';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { NeuralFieldBackground } from '../components/NeuralFieldBackground';
import { StickyHeader } from '../components/StickyHeader';
export function LandingPage() {
  return <div className="relative min-h-screen" data-id="element-455">
      <NeuralFieldBackground data-id="element-456" />
      <StickyHeader data-id="element-457" />
      <div className="relative z-10" data-id="element-458">
        <Hero data-id="element-459" />
        <WhoThisIsFor data-id="element-460" />
        <Testimonials data-id="element-461" />
        <LifestyleGallery data-id="element-462" />
        <WhyNow data-id="element-463" />
        <Curriculum data-id="element-464" />
        <Experience data-id="element-465" />
        <Faculty data-id="element-466" />
        <Pricing data-id="element-467" />
        <ApplicationProcess data-id="element-468" />
        <FAQ data-id="element-469" />
        <FinalCTA data-id="element-470" />
      </div>
    </div>;
}